const removeBase64Data = (imageBase64) => imageBase64.replace(/data:.+?,/, '');

export { removeBase64Data };
